import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import { Button } from 'global/components/Button'
import { Clock } from 'global/components/Clock'
import Dialog from 'global/guides/Dialog'
import { ClockPlusIcon } from 'lucide-react'
import React from 'react'
import { funcionario } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import { invalidateDigitacaoQueries } from '../pages/useDigitacaoData'

export const BaterPontoButton = () => {
    const funcionario = useStore(state => state.employee)

    if (funcionario?.registroWeb !== 'S') return null

    return (
        <>
            <Button
                color="primary"
                startIcon={<ClockPlusIcon />}
                href="bater-ponto"
            >
                Bater ponto
            </Button>
            <Divider orientation="vertical" flexItem />
        </>
    )
}

const BaterPontoModal: React.FC = () => {
    const [{ value: nomeTimezone }] = new Intl.DateTimeFormat('pt-BR', {
        timeZoneName: 'long',
    })
        .formatToParts(new Date())
        .filter(part => part.type === 'timeZoneName')

    const empresaId = useStore(state => state.companyId)
    const { mutateAsync, isLoading } =
        funcionario.baterPonto.mutations.useCreate({
            onSuccess: async () => {
                toast.success('Ponto batido com sucesso!')
                await invalidateDigitacaoQueries()
            },
            onError: (error: any) => {
                toast.error(error.message)
                console.error(error)
            },
        })

    return (
        <Dialog.Root
            loading={isLoading}
            height="fit-content"
            width="max-content"
            onSubmit={async () => mutateAsync({ empresaId })}
        >
            <Dialog.Title>Bater ponto</Dialog.Title>
            <Dialog.Content>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column',
                    }}
                >
                    <Clock className="text-3xl" />
                    <Divider className="w-full">{nomeTimezone}</Divider>
                </Box>
            </Dialog.Content>
            <Dialog.Actions
                sx={{
                    justifyContent: 'space-evenly',
                }}
            >
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit>
                    Registrar
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}

export default BaterPontoModal
